// src/services/companiesLookupService.js
import { fetchWithAuth } from '../utils/fetchWithAuth';

/** Obtiene una compañía por RUT. */
export const getCompanyByRut = async (rut) => {
  if (!rut) throw new Error('RUT es requerido');
  try {
    const res = await fetchWithAuth(`/companies/rut/${encodeURIComponent(rut)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    // si quieres mapear 404 a null aquí, descomenta:
    // if (res.status === 404) return null;

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.message || `HTTP error! status: ${res.status}`);
    }
    return await res.json();
  } catch (error) {
    console.error('Error al obtener compañía por RUT:', error);
    throw error;
  }
};

/**
 * Trae la compañía del usuario actual usando RUT del localStorage.
 * Devuelve `null` si no hay RUT o si la API responde 404.
 */
export const getMyCompany = async () => {
  const rut = localStorage.getItem('rut');
  if (!rut) return null; // <- más seguro para el Navbar

  try {
    return await getCompanyByRut(rut);
  } catch (e) {
    // si el backend devuelve 404/Not Found, devolvemos null
    if (e?.message?.includes('404')) return null;
    console.warn('getMyCompany fallback -> null:', e);
    return null;
  }
};
